<div class="flex flex-col gap-3 p-4 lg:w-[25rem] h-full">
    <div class="flex justify-end">
        <app-document-back-button />
    </div>
    <app-input
        placeholder="아동명으로 검색하세요."
        [(value)]="query"
        (valueChange)="filterChange()"
        [debounce]="300"
    />
    <div class="flex w-full justify-between items-center">
        <div class="flex gap-3 items-center flex-wrap">
            <app-custom-select
                label="치료 상태"
                mode="button"
                bindLabel="label"
                bindValue="value"
                [(value)]="ticketStatusList"
                (valueChange)="filterChange()"
                [items]="ticketStatusOptions"
                multiple
            />
            @if (documentRead()) {
                <app-custom-select
                    label="담당 선생님"
                    mode="button"
                    bindLabel="username"
                    bindValue="id"
                    [(value)]="teacherIds"
                    (valueChange)="filterChange()"
                    [items]="teacherOptions()"
                    multiple
                />
            }
            <app-custom-select
                label="바우처"
                mode="button"
                bindLabel="name"
                bindValue="name"
                [(value)]="vouchers"
                (valueChange)="filterChange()"
                [items]="voucherOptions()"
                multiple
            />
        </div>

        <app-checkbox
            label="내 아동"
            size="sm"
            [(value)]="onlyMyChildren"
            (valueChange)="filterChange()"
        />
    </div>
    <div
        class="flex flex-col gap-3 overflow-y-auto max-h-[70rem] items"
        appInfiniteScroll
        [hasNext]="hasNextPage()"
        (next)="next()"
        type="element"
    >
        @for (item of sortChilds(); track $index) {
            <app-document-select-child-card
                animate.enter="fade-in"
                [item]="item"
                (click)="currentChild.set(item)"
            />
        }
        <div class="pb-[20rem]"></div>
    </div>
</div>
